import { getAxiosFulfilledState, getPendingState, getRejectedState, resetState } from '../helpers/reducerHelper'
import { IReduxAction } from './index'
import { FileAction, FileMutationDto, IFileDto } from '../config/fileConfig'
import { FileListItemDto } from '../context/FileContext'
import { NoteOverviewDto } from '../config/noteConfig'
import { ActionType } from 'redux-promise-middleware'
import { Message } from '@microsoft/microsoft-graph-types'
import { DataPromise, getDataEmptyState, IGraphArrayPayload } from '../context/AxiosContext'

export interface IFileState {
    list: DataPromise<FileListItemDto[]>
    current: DataPromise<IFileDto>
    mutation: DataPromise<FileMutationDto>
    emails: DataPromise<IGraphArrayPayload<Message>>
    notes: DataPromise<NoteOverviewDto[]>
    suggestedReference?: string
}

const defaultState: IFileState = {
    list: getDataEmptyState<FileListItemDto[]>(undefined, []),
    current: getDataEmptyState<IFileDto>(),
    mutation: getDataEmptyState<FileMutationDto>(),
    emails: getDataEmptyState<IGraphArrayPayload<Message>>(),
    notes: getDataEmptyState<NoteOverviewDto[]>(undefined, []),
    suggestedReference: null,
}

export default function reducer(state: IFileState = defaultState, action: IReduxAction): IFileState {
    switch (action.type) {
        case `${FileAction.GetList}_${ActionType.Pending}`: {
            return getPendingState(state, 'list')
        }
        case `${FileAction.GetList}_${ActionType.Rejected}`: {
            return getRejectedState(state, action, 'list')
        }
        case `${FileAction.GetList}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'list')
        }
        case FileAction.ResetList: {
            // Reset the state to force other components to update the data.
            return resetState(state, { list: null })
        }
        case `${FileAction.Get}_${ActionType.Pending}`: {
            return getPendingState(state, 'current')
        }
        case `${FileAction.Get}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'current')
        }
        case `${FileAction.GetMutation}_${ActionType.Pending}`: {
            return getPendingState(state, 'mutation')
        }
        case `${FileAction.GetMutation}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'mutation')
        }
        case `${FileAction.GetEmails}_${ActionType.Pending}`: {
            return getPendingState(state, 'emails')
        }
        case `${FileAction.GetEmails}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'emails')
        }
        case `${FileAction.GetEmails}_${ActionType.Rejected}`: {
            return getRejectedState(state, action, 'emails')
        }
        case `${FileAction.GetNotes}_${ActionType.Pending}`: {
            return getPendingState(state, 'notes')
        }
        case `${FileAction.GetNotes}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'notes')
        }
        case `${FileAction.Add}_${ActionType.Fulfilled}`:
        case `${FileAction.Update}_${ActionType.Fulfilled}`:
        case `${FileAction.Delete}_${ActionType.Fulfilled}`: {
            // Reset the state to force other components to update the data.
            return resetState<IFileState>(state, {
                list: [],
                complete: null,
            })
        }
        case FileAction.ResetCurrent: {
            return resetState(state, {
                current: null,
                emails: null,
                notes: null,
            })
        }
        case FileAction.ResetEmails: {
            return resetState(state, { emails: null })
        }
        case FileAction.ResetNotes: {
            return resetState(state, { notes: null })
        }
    }

    return state
}
